import { BASE_URL } from "../constants";
import { VendorPorsiEntity } from "../entities/VendorPorsiEntity";
import FetchUtils from "../utils/fetch";

class VendorPorsiService {
    static async GetAllVendorsPorsi(start_date: string | null, end_date: string | null): Promise<VendorPorsiEntity[]> {
        let resp : any
        if (start_date == null || end_date == null) {
            resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/porsi`);
        } else {
            resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/porsi?start_date=${start_date}&end_date=${end_date}`);
        }
        if (resp.status != 200) { throw resp.message }
        const data: VendorPorsiEntity[] = [];
        for (let i = 0; i < resp.data.length; i++) {
            data.push(new VendorPorsiEntity({
                id: resp.data[i].ID,
                id_vendor: resp.data[i].IDVendor,
                id_lokasi: resp.data[i].IDLokasi,
                shift: resp.data[i].Shift,
                qty_regular: resp.data[i].QtyPorsiRegular,
                qty_vegetarian: resp.data[i].QtyPorsiVegetarian,
                taken_regular_tapping: resp.data[i].TakenRegularTapping,
                taken_regular_dropoff: resp.data[i].TakenRegularDropoff,
                taken_regular_guest: resp.data[i].TakenRegularGuest,
                taken_vegetarian_tapping: resp.data[i].TakenVegetarianTapping,
                taken_vegetarian_dropoff: resp.data[i].TakenVegetarianDropoff,
                taken_vegetarian_guest: resp.data[i].TakenVegetarianGuest,
                sisa_regular: resp.data[i].SisaRegular,
                sisa_vegetarian: resp.data[i].SisaVegetarian,
                tanggal: resp.data[i].Tanggal,
                datetime_in: resp.data[i].DatetimeIn,
                vendor: resp.data[i].Vendor,
                lokasi: resp.data[i].Lokasi,
            }))
        }

        return data;
    }

    static async AddVendorsPorsi(data: { id_lokasi: number, qty_regular: number, qty_vegetarian: number }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/porsi/add`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return resp;
    }

    static async UpdateVendorsPorsi(data: VendorPorsiEntity, fields: { qty_regular?: number, qty_vegetarian?: number }): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/porsi/update`,
            {
                method: 'PUT',
                body: JSON.stringify({ id: data.id, fields })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }

    static async DeleteVendorsPorsi(data: VendorPorsiEntity): Promise<{ message: string }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/porsi/delete`,
            {
                method: 'DELETE',
                body: JSON.stringify({ id: data.id })
            }
        );
        if (resp.status != 200) { throw resp.message }

        return resp;
    }
}

class TappingService {
    static async GetAvailablePorsi(id_location: number, id_vendor?: number, tanggal?: string, shift?: number) {
        let resp = await FetchUtils.fetchAuth(
            `${BASE_URL}/api/v1/vendors/porsi/available?id_location=${id_location}${id_vendor == null ? '' : `&id_vendor=${id_vendor}`}${tanggal == null ? '' : `&tanggal=${tanggal}`}${shift == null ? '' : `&shift=${shift}`}`
        );
        if (resp.status != 200) { throw resp.message }

        const data: {
            id_vendor_porsi: number,
            shift: number,
            vendor: Date,
            lokasi: Date,
            sisa_regular: number,
            sisa_vegetarian: number
        } = {
            id_vendor_porsi: resp.data.ID,
            shift: resp.data.Shift,
            vendor: resp.data.Vendor,
            lokasi: resp.data.Lokasi,
            sisa_regular: resp.data.SisaRegular,
            sisa_vegetarian: resp.data.SisaVegetarian
        };

        return data;
    }

    static async TappingKaryawan(
        data: { id_vendor_porsi: number, ncode: string, tipe: "VEGETARIAN" | "REGULAR" }
    ): Promise<{ message: string, data: { nama: string, id_card: string } }> {
        let resp = await FetchUtils.fetchAuth(`${BASE_URL}/api/v1/vendors/porsi/tapping`,
            {
                method: 'POST',
                body: JSON.stringify({ ...data })
            }
        );
        if (resp.status != 200) { throw resp.message }
        return { message: resp.message, data: { nama: resp.data.Nama, id_card: resp.data.IDCard } };
    }
}

export { VendorPorsiService, TappingService };